import {Component, Inject} from '@angular/core';
import {smoothlyMenu} from '../../../app.helpers';
import {RestAbstractService} from "../../../services/abstract/rest.abstract.service";
import {RestService} from "../../../services/rest.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {Router} from "@angular/router";

declare var jQuery:any;

@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html',
})
export class TopNavbarComponent {

  toggleNavigation(): void {
    jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

  constructor(@Inject(RestService) private restService: RestAbstractService, private auth: AuthenticationService, private router: Router){ }

  logout(){
    this.restService.post('api/logout').subscribe(
        data => {
          localStorage.removeItem('token_umotion');
          localStorage.clear();
          this.auth.logout();
          this.router.navigate(['login']);
        },
        error => {
          localStorage.clear();
          this.auth.logout();
          this.router.navigate(['login']);
          console.log(error);
        }
    )
  }
}
